import {Form, Formik} from "formik";
import React, {FC} from "react";
import {OrderAddress} from "../redux/types";
import {useHistory} from "react-router-dom";
import {CircularProgress, Divider, IconButton, makeStyles, Typography} from "@material-ui/core";
import clsx from "clsx";
import {FormikSelect} from "../../../form/FormikSelect";
import {FormikTextField} from "../../../form/FormikTextField";
import {FormikDcbAddressInput} from "../../../sharedComponents/DcbAddressInput";
import {RedCloseIcon} from "../../../sharedComponents/RedCloseIcon";
import {GreenCheckIcon} from "../../../sharedComponents/GreenCheckIcon";

const useStyles = makeStyles(theme => ({
    spacingRight: {
        marginRight: theme.spacing(1)
    },
    spacingBottom: {
        marginBottom: theme.spacing(2)
    },
    nameContainer: {
        display: 'flex',
        alignItems: 'center'
    },
    select: {
        width: 100
    }
}));

const emptyInitialValue: OrderAddress = {
    name: {
        firstName: '',
        lastName: '',
        salutation: 'Herr'
    },
    phone: '',
    address: {
        formattedAddress: '',
        placeId: '',
        lat: 0,
        long: 0
    }
}

interface EditableAddressWithNameProps {
    initialValues?: OrderAddress;
    onSubmit: (addressWithName: OrderAddress) => Promise<void>;
    className?: string;
    isInvoiceAddress?: boolean;
}

export const AddressWithNameForm: FC<EditableAddressWithNameProps> = ({initialValues, onSubmit, className, isInvoiceAddress}) => {

    const classes = useStyles();
    const history = useHistory();

    const [isLoading, setIsLoading] = React.useState(false);

    const closeForm = () => history.replace({search: undefined});

    return (
        <Formik
            initialValues={initialValues ?? emptyInitialValue}
            onSubmit={(values) => {
                setIsLoading(true);
                onSubmit(values)
                    .catch(() => {
                    })
                    .finally(() => {
                        setIsLoading(false);
                        closeForm();
                    })
            }}
        >
            {({submitForm}) => (
                <Form className={className}>
                    <Typography
                        variant="body1"
                        color="primary"
                    >
                        { isInvoiceAddress ? ("Rechnungsadresse") : ("Auftragsadresse")}
                        {isLoading
                            ? <CircularProgress size={20} color="secondary"/>
                            : (
                                <>
                                    <IconButton edge="end" onClick={closeForm}>
                                        <RedCloseIcon fontSize="inherit"/>
                                    </IconButton>
                                    <IconButton edge="end" color="secondary" onClick={submitForm}>
                                        <GreenCheckIcon fontSize="inherit"/>
                                    </IconButton>
                                </>
                            )
                        }
                    </Typography>
                    <Divider className={classes.spacingBottom}/>
                   <div className={clsx(classes.nameContainer, classes.spacingBottom)}>
                       <FormikSelect
                           name={"name.salutation"}
                           label="Anrede"
                           required
                           options={[
                               {value: 'Herr', label: 'Herr'},
                               {value: 'Frau', label: 'Frau'},
                               {value: 'Divers', label: 'Divers'},
                           ]}
                           className={clsx(classes.spacingRight, classes.select)}
                       />
                       <FormikTextField required name={"name.firstName"} label="Vorname" className={classes.spacingRight}/>
                       <FormikTextField required name={"name.lastName"} label="Nachname"/>
                   </div>
                    <FormikTextField name={"name.companyName"} label="Firma" className={classes.spacingBottom} fullWidth/>
                    <FormikTextField name={"phone"} label="Telefon" className={classes.spacingBottom} fullWidth/>
                    <FormikDcbAddressInput name={"address"} label="Adresse" textFieldProps={{required: true}}/>
                </Form>
            )}
        </Formik>
    )
}

